module.exports = __webpack_public_path__ + "img/logo.5a390e65.png";